import React from 'react';

import VehicleEditForm from '@components/form/VehicleEditForm';

interface Props {
  vehicleId: string;
}

const VehicleUpdateForm = ({vehicleId}: Props): JSX.Element => <VehicleEditForm vehicleId={vehicleId} locked />;

export default React.memo(VehicleUpdateForm);
